// Renders backend service error responses for toasts.
//
// The backend (ValidationServiceErrors) returns one or more error strings,
// separated by newlines. A string is either a controlled MappedMessages key
// (which has an i18n translation) or opaque third-party diagnostic text
// (e.g. a raw FortNox error). Translate the former, print the latter as-is.
//
// Note: opaque text may contain "{...}" (JSON), so we only run a line through
// react-intl when it matches a known key — formatMessage on arbitrary text
// would break on the ICU parser.
export const formatServiceError = (intl, raw) =>
  String(raw ?? "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((key) => (intl.messages[key] ? intl.formatMessage({ id: key }) : key))
    .join("\n");
